import CheckIcon from "../../assets/icons/checkIcon";
import XIcon from "../../assets/icons/xIcon";

import BoltIcon from "../../assets/icons/boltIcon";
import OpenInNewIcon from "../../assets/icons/openInNew";
import RefreshIcon from "../../assets/icons/refreshIcon";
import RocketIcon from "../../assets/icons/rocketIcon";
import { useDashboardContext } from "../../context/dashboardContext";
import PieceConfirmedHistoryPopUp from "../../pageparts/popup/pieceConfirmedHistoryPopUp";
import AcceptPiecePopUp from "../acceptPiecePopUp";
import ConfirmPiecePopUp from "../confirmPiecePopUp";
import { openPopUp } from "../popUp";
import "./pieceConfirmDisplay.css";
import { PieceAdminResponseDTO } from "../../openapi-generated-client";

interface PieceConfirmDisplayProps {
    pieceData?: PieceAdminResponseDTO;
    linkPrefix?: string;
    hideComposer?: boolean;
    hideIconDisplay?: boolean;
    hideInfos?: boolean;
    hideInstrumentation?: boolean;
    refetch?: () => void;
    children?: any;
}

export default function PieceConfirmWrapper(props: PieceConfirmDisplayProps) {

    const {sessionId, appContext} = useDashboardContext();
    const {pieceController} = appContext;

    if(!props.pieceData) return <></>;

    async function sendPieceAcception(confirmed: boolean, message: string) {
        if(!props.pieceData?.piece.id) {
            console.log("Invalid piece id");
            return;
        }
        await pieceController.confirm(props.pieceData?.piece.id, sessionId, {
            confirmed: confirmed,
            message: message
        });
        props.refetch?.();
    }

    return <div className="piece-confirm-display">
        <div className="actions">
            <div className="action pdf" onClick={() => {
                window.open("/pieces/" + props.pieceData?.piece.id, "_blank");
            }}>
                <OpenInNewIcon/>
            </div>
            <div onClick={() => {
                if(!props.pieceData) return;
                openPopUp(<PieceConfirmedHistoryPopUp pieceData={props.pieceData.piece} confirmedHistory={props.pieceData.messageHistory}/>);
            }} className={"confirm-state action" + (props.pieceData.status === "PENDING" ? "" : props.pieceData.status === "REJECTED_BUT_EDITED" ? " yellow" : " brown")}>
                {props.pieceData.status === "PENDING" ? <RocketIcon/> : props.pieceData.status === "REJECTED_BUT_EDITED" ? <RefreshIcon/> : <BoltIcon/>}
            </div>
            <div className="action red" onClick={() => {
                openPopUp(<ConfirmPiecePopUp onSend={(message) => {
                    sendPieceAcception(false, message);
                }}/>);
            }}>
                <XIcon/>
            </div>
            <div className="action green" onClick={() => {
                openPopUp(<AcceptPiecePopUp onSend={() => {
                    sendPieceAcception(true, "");
                }}/>);
            }}>
                <CheckIcon/>
            </div>
        </div>
            {props.children}
        
    </div>;
}

export type { PieceConfirmDisplayProps };
